import { useFormat } from "@/i18n/format";

/**
 * A signed amount, rendered for reading in a column.
 *
 * Two rules from `project.md` §5.5 live here so no caller can forget them:
 * tabular figures with right alignment, so digits line up down a column; and
 * **red reserved strictly for overspend**. A negative amount is not an error —
 * every expense is negative (`model.md` §2.2 rule 1) — so it is rendered in the
 * ordinary text colour. Colouring every expense red would make the one figure
 * that should alarm somebody indistinguishable from the forty that should not.
 */
export function Amount({
  minor,
  currency,
  symbol = true,
  className = "",
  testId = "amount",
}: {
  minor: number;
  currency: string;
  symbol?: boolean;
  className?: string;
  /** Overridden where two amounts sit in one cell, so each can be read alone. */
  testId?: string;
}) {
  // The reader's locale, not the currency's: a British reader looking at a euro
  // account sees €1,234.50, because the separators belong to whoever is reading
  // and the symbol belongs to the money.
  const format = useFormat();
  const text = symbol ? format.amount(minor, currency) : format.plain(minor, currency);
  return (
    <span className={`num ${className}`} data-testid={testId}>
      {text}
    </span>
  );
}
